"use strict";
const { publicRoute, publicPath, PUBLIC_PATHS } = require('./routes');
const metadata = {
 '/': {
  es: ['Astroanamnesis | Carta Tropical, Memoria Inconsciente y Sideral', 'Astroanamnesis reúne la Carta Tropical, la Memoria Inconsciente y la Carta Sideral, y permite organizar cartas y preparar prompts para el GPT de Eliseo Gallardo.'],
  en: ['Astroanamnesis | Tropical Chart, Unconscious Memory and Sidereal Chart', 'Astroanamnesis brings together the Tropical Chart, Unconscious Memory and Sidereal Chart, allowing you to organise charts and prepare prompts for Eliseo Gallardo’s GPT.']
 },
 '/astroanamnesis': {
  es: ['El método Astroanamnesis | Astroanamnesis', 'Conoce el método Astroanamnesis y sus tres mapas de observación: Tropical, Memoria Inconsciente y Sideral.'],
  en: ['The Astroanamnesis method | Astroanamnesis', 'Explore the Astroanamnesis method and its three maps of observation: Tropical, Unconscious Memory and Sidereal.']
 },
 '/crear-carta': {
  es: ['Crear una carta | Astroanamnesis', 'Introduce los datos natales para consultar tu carta en Astroanamnesis.'],
  en: ['Create a chart | Astroanamnesis', 'Enter your birth details to view your chart in Astroanamnesis.']
 },
 '/donaciones': {
  es: ['Aportaciones al proyecto | Astroanamnesis', 'Ayuda a mantener y continuar el desarrollo de Astroanamnesis.'],
  en: ['Contribute to the project | Astroanamnesis', 'Help maintain Astroanamnesis and support its continued development.']
 }
};
const offerCopy = require('./messages/public-offers.json');
for (const [path, key] of [['/suscripcion','subscription'],['/informes','reports'],['/sesiones','sessions'],['/tienda','store']]) {
 metadata[path] = Object.fromEntries(['es','en'].map(lang => [lang,[offerCopy[key][lang]+' | Astroanamnesis',offerCopy[key+'Intro'][lang]]]));
}
const escape = text => String(text).replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
function pageMetadata(pathname, origin = 'https://astroanamnesis.com') {
 const route=publicRoute(pathname);if(!route)return null;
 const [title,description]=metadata[route.path][route.language];
 return {title,description,language:route.language,canonical:origin+publicPath(route.path,route.language),
  alternates: {es:origin+publicPath(route.path,'es'),en:origin+publicPath(route.path,'en')}};
}
function renderPage(html, pathname, origin) {
 const meta=pageMetadata(pathname,origin);
 if(!meta)return html.replace('</head>','<meta name="robots" content="noindex,nofollow"></head>');
 if(meta.language==='en')html=html.replace(/href="\/(suscripcion|informes|sesiones|tienda)" data-offer-path/g,'href="/en/$1" data-offer-path');
 return html.replace(/<html lang="[^"]*"/,`<html lang="${meta.language}"`)
  .replace(/<title>[\s\S]*?<\/title>/,`<title>${escape(meta.title)}</title>`)
  .replace(/<meta name="description" content="[^"]*">/,`<meta name="description" content="${escape(meta.description)}">`)
  .replace('</head>',`<link rel="canonical" href="${escape(meta.canonical)}"><link rel="alternate" hreflang="es" href="${escape(meta.alternates.es)}"><link rel="alternate" hreflang="en" href="${escape(meta.alternates.en)}"><link rel="alternate" hreflang="x-default" href="${escape(meta.alternates.es)}"></head>`);
}
function sitemap(origin='https://astroanamnesis.com') {
 return '<?xml version="1.0" encoding="UTF-8"?><urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">'+PUBLIC_PATHS.flatMap(path=>['es','en'].map(language=>`<url><loc>${escape(origin+publicPath(path,language))}</loc></url>`)).join('')+'</urlset>';
}
module.exports={pageMetadata,renderPage,sitemap};
